import { render, staticRenderFns } from "./ProductionDetail.vue?vue&type=template&id=18430e42"
import script from "./ProductionDetail.vue?vue&type=script&lang=js"
export * from "./ProductionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports